export default "__VITE_ASSET__e8788d1a__"